<tr>
  <td *ngIf="isExpandable">
    <button
      *ngIf="edition.hasItems"
      class="panel-expansion-button"
      data-automation-id="expand-loc-info"
      [attr.aria-label]="'epanCollapseEditionPanel' | translate"
      [attr.aria-expanded]="edition.availability?.expanded"
      (click)="toggleEdition(edition)">
      <fa-icon class="arrow-icon" [icon]="edition.availability?.expanded ? arrowIconUp : arrowIconDown"></fa-icon>
    </button>
  </td>
  <td data-automation-id="publication-date-cell">{{ edition.publicationDate || '—' }}</td>
  <td data-automation-id="edition-cell">{{ edition.edition || '—' }}</td>
  <td data-automation-id="details-cell">
    <button
      class="ins-buttons button-primary details"
      data-automation-id="details-popup-button"
      [tippy]="'showDetailsPopup' | translate"
      [attr.aria-label]="'showDetailsPopup' | translate"
      (click)="showDetails(edition)">
      <fa-icon class="info-icon" [icon]="infoCircle"></fa-icon>
    </button>
  </td>
  <td data-automation-id="publisher-cell">{{ edition.publisher || '—' }}</td>
  <td data-automation-id="description-cell">
    <ng-container *ngIf="!edition.physicalDescription; else description">
      <span> — </span>
    </ng-container>
    <ng-template #description>
      {{ edition?.physicalDescription }}
    </ng-template>
  </td>
  <td data-automation-id="availability-cell">
    <span>{{ statusKeys[edition?.availabilityStatus] | translate }}</span>
  </td>
  <td data-automation-id="actions-cell">

    <ng-container *ngIf="!offer; else offeravailable">
      <button
        class="ins-buttons no-border button-primary flint w-100"
        data-automation-id="place-hold-btn"
        translate
        (click)="onGetIt($event)"
        [attr.aria-describedby]="'get-offers-button'"
      >
        Get it
      </button>
    </ng-container>
    <ng-template #offeravailable>
      <button
        class="ins-buttons no-border button-primary flint w-100"
        data-automation-id="place-hold-btn"
        translate
        (click)="onGetIt($event)"
        [attr.aria-describedby]="'get-offers-button'"
      >
        Get it
      </button>
    </ng-template>
  </td>

</tr>
